import React, { useEffect } from 'react';
import { ScrollView,View ,useWindowDimensions} from 'react-native';
import FeedDetails from '../components/FeedDetails';
import { fetchfeedbackdetailswidgets } from '../actions/fetchfeedbackdetailswidget';
import { fetchfeedbackdetailsdata } from '../actions/fetchFeedBackDetailsData';
import { bindActionCreators } from 'redux';
import get from 'lodash/get';
import { connect } from 'react-redux';
import { useLocation } from 'react-router-dom';

const FeedBackDetails = props => {
  const { width } = useWindowDimensions();
  const isMobile = width < 768;
  const location = useLocation();
  const pathParts = location.pathname.split('/');

  const feedback_id = pathParts[pathParts.length - 1];

  const { actions, feedback_details_widget_data, feedback_details_data, hotels, note_response, alert_response } = props;

  const isWidgetLoading = !feedback_details_widget_data?.contents;
  const isDetailsLoading = !feedback_details_data?.contents;
  const isLoading = isWidgetLoading || isDetailsLoading;

  const hotelCount = Object.keys(hotels || {}).length;

  let role = 'property';
  if (hotelCount > 1) {
    role = 'muo';
  } else {
    role = 'property';
  }

  useEffect(() => {
    actions.fetchfeedbackdetailswidgets();
  }, [actions]);

  useEffect(() => {
    if (feedback_id) {
      actions.fetchfeedbackdetailsdata(feedback_id);
    }
  }, [feedback_id]);

  return (
    <ScrollView style={{ marginVertical: isMobile ? 0 : 30, marginHorizontal: isMobile ? 0 : 40 }}>
      <FeedDetails
        feedback_details={feedback_details_data?.contents}
        feedback_widget_details={feedback_details_widget_data}
        role={role}
        feedback_id={feedback_id}
        note_response={note_response}
        alert_response={alert_response}
        isLoading={isLoading}
      />
    </ScrollView>
  );
};

const mapStateToProps = state => ({
  feedback_details_widget_data: state.feedbackdetailsreducer.feedback_details_widget_data,
  feedback_details_data: state.feedbackdetailsreducer.feedback_details_data,
  note_response: state.feedbackdetailsreducer.note_response,
  hotels: get(state, 'entities.hotels', {}),
  alert_response: state?.alertSummaryReducer?.alert_response
});

const mapDispatchToProps = dispatch => ({
  actions: bindActionCreators(
    {
      fetchfeedbackdetailswidgets,
      fetchfeedbackdetailsdata
    },
    dispatch
  )
});

export default connect(mapStateToProps, mapDispatchToProps)(FeedBackDetails);
